import {IRange} from "@pg-design/range-module";

import {PRICE_FIELD_CONTENT} from "@/components/price_field/constants/price_field_content";
import {roomsPlural} from "@/features/properties/constants/rooms_plural";

import {HOME_MATCH_SURVEY_DEFAULT_PRICE_MAX} from "../constants/home_match_survey_defaults";
import {HOME_MATCH_PREFERENCES_WIZARD_CONTENT} from "../constants/preferences/home_match_preferences_wizard_content";
import {IHomeMatchUserPreferencesForm} from "../types/home_match_preferences";

const {ANY_ROOMS} = HOME_MATCH_PREFERENCES_WIZARD_CONTENT.SUMMARY;
const {CURRENCY_SUFFIX, UNLIMITED_LABEL} = PRICE_FIELD_CONTENT;

export const getHomeMatchBasicRoomsText = (rooms: IRange<number> | null) => {
    const lower = rooms?.lower;
    const upper = rooms?.upper;

    if (!lower && !upper) {
        return ANY_ROOMS;
    }

    if (lower && upper && lower !== upper) {
        return `${lower}-${upper} ${roomsPlural(upper)}`;
    }

    const value = lower || upper || 0;

    return `${value} ${roomsPlural(value)}`;
};

export const getHomeMatchBasicBudgetText = (price: IHomeMatchUserPreferencesForm["price"]) => {
    const budget = price?.upper;

    if (!budget || budget >= HOME_MATCH_SURVEY_DEFAULT_PRICE_MAX) {
        return UNLIMITED_LABEL;
    }

    return `do ${budget.toLocaleString("pl-PL")} ${CURRENCY_SUFFIX}`;
};
import {IRange} from "@pg-design/range-module";

import {PRICE_FIELD_CONTENT} from "@/components/price_field/constants/price_field_content";
import {roomsPlural} from "@/features/properties/constants/rooms_plural";

import {HOME_MATCH_SURVEY_DEFAULT_PRICE_MAX} from "../constants/home_match_survey_defaults";
import {HOME_MATCH_PREFERENCES_WIZARD_CONTENT} from "../constants/preferences/home_match_preferences_wizard_content";
import {IHomeMatchUserPreferencesForm} from "../types/home_match_preferences";

const {ANY_ROOMS} = HOME_MATCH_PREFERENCES_WIZARD_CONTENT.SUMMARY;
const {CURRENCY_SUFFIX, UNLIMITED_LABEL} = PRICE_FIELD_CONTENT;

export const getHomeMatchBasicRoomsText = (rooms: IRange<number> | null) => {
    const lower = rooms?.lower;
    const upper = rooms?.upper;

    if (!lower && !upper) {
        return ANY_ROOMS;
    }

    if (lower && upper && lower !== upper) {
        return `${lower}-${upper} ${roomsPlural(upper)}`;
    }

    const value = lower || upper || 0;

    return `${value} ${roomsPlural(value)}`;
};

export const getHomeMatchBasicBudgetText = (price: IHomeMatchUserPreferencesForm["price"]) => {
    const budget = price?.upper;

    if (!budget || budget >= HOME_MATCH_SURVEY_DEFAULT_PRICE_MAX) {
        return UNLIMITED_LABEL;
    }

    return `do ${budget.toLocaleString("pl-PL")} ${CURRENCY_SUFFIX}`;
};
